<template>
    <el-select v-bind="$attrs" placeholder="" :clearable="clearable" :filterable="filterable" :value="value" @input="change">
        <template slot="prefix">
            <flag :squared="false" :iso="value" v-if="value"/>
        </template>
        <el-option v-for="(item, index) in allPaises" :key="index" :value="item.codigo" :label="item.nombre">
            <span><flag :squared="false" :iso="item.codigo"/> {{ item.nombre }}</span>
        </el-option>
    </el-select>
</template>

<style lang="scss">
    .el-select {
        @apply w-full;
    }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      nameCountry: ''
    }
  },
  computed: {
    ...mapGetters('paises', { allPaises: 'all' })
  },
  methods: {
    ...mapActions('paises', { getAllPaises: 'getAll' }),
    getAll () {
      Promise.all([
        this.getAllPaises()
      ]).then(() => {
      })
    },
    change (data) {
      if (data) {
        this.allPaises.forEach(item => {
          if (item.codigo === data) {
            this.nameCountry = item.nombre
          }
        })
      } else {
        this.nameCountry = ''
      }
      this.$emit('input', data, this.nameCountry)
    }
  },
  mounted () {
    this.getAll()
  }
}
</script>
